import React from 'react';
import {ContextMenu} from './ContextMenu';
import {getMessage} from '../utils/messages';
import {getBreadcrumbWithoutLeaf} from '../utils/taskUtils';
import type {ProjectTimeRecord} from '../types/types';
import {formatDuration} from "@/shared/utils/datefunctions";

type MonthlyEntryTableProps = {
	entries: ProjectTimeRecord[];
	isLoading: boolean;
	isSaving: boolean;
	isFormOpen: boolean;
	canEditEntry: (entry: ProjectTimeRecord) => boolean;
	onStartEdit: (entry?: ProjectTimeRecord, isNew?: boolean) => void;
	onDeleteEntry: (entry: ProjectTimeRecord) => Promise<void>;
};

export const MonthlyProjectTimeTable: React.FC<MonthlyEntryTableProps> = ({
																			  entries,
																			  isLoading,
																			  isSaving,
																			  isFormOpen,
																			  canEditEntry,
																			  onStartEdit,
																			  onDeleteEntry,
																		  }) => {
	const actionsDisabled = isSaving || isFormOpen;
	return (
		<div className="panel panel-default" style={{overflow: 'visible'}}>
			<div className="panel-heading clearfix" style={{height: 65, verticalAlign: 'middle'}}>
				<h5 className="panel-title pull-left">{getMessage('monthlyRecording.table.title')}</h5>
			</div>
			<div className="table-responsive" style={{overflow: 'visible'}}>
				<table className="table table-striped">
					<thead>
					<tr>
						<th style={{width: 35}}></th>
						<th style={{width: '25%'}}>{getMessage('record.task')}</th>
						<th style={{
							width: 60,
							textAlign: "right",
							paddingRight: 15,
							paddingLeft: 15
						}}>{getMessage('record.duration')}</th>
						<th style={{width: '55%'}}>{getMessage('record.bulksetnote.title')}</th>
					</tr>
					</thead>
					<tbody>
					{isLoading && (
						<tr>
							<td colSpan={4} className="text-muted">{getMessage('monthlyRecording.table.loading')}</td>
						</tr>
					)}
					{!isLoading && entries.length === 0 && !isFormOpen && (
						<tr>
							<td colSpan={4} className="text-muted">{getMessage('monthlyRecording.table.empty')}</td>
						</tr>
					)}
					{entries.map(entry => {
						const canEdit = canEditEntry(entry);
						return (
							<tr key={entry.id ?? `record-${entry.task?.id}-${entry.start}`}>
								<td className="text-center" style={{overflow: 'visible', verticalAlign: 'middle'}}>
									<ContextMenu
										entry={entry}
										canEdit={canEdit}
										isDisabled={actionsDisabled}
										onStartEdit={onStartEdit}
										onDeleteEntry={onDeleteEntry}
									/>
								</td>
								<td>
									<div>{entry.task?.name ?? '—'}</div>
									{entry.task?.breadCrumbs && (
										<div className="text-muted small">
											{getBreadcrumbWithoutLeaf(entry.task)}
										</div>
									)}
								</td>
								<td className="text-right">
									<span>{entry.durationNet ? formatDuration(entry.durationNet) : '—'}</span>
								</td>
								<td>
									<span>{entry.description ?? '—'}</span>
								</td>
							</tr>
						);
					})}
					</tbody>
				</table>
			</div>
		</div>
	);
};
